import {ajax_get,ajax_post} from "./index";

// 获取所有商铺列表
export const getALLMenu = (data) => ajax_get('/museummenu', data);


export const getInfo = (data) => ajax_get('/museumfillinfo', data);


export const getbaseInfo = (data) => ajax_get('/museuminfo', data);

export const otherfiles = (data)=>ajax_get('/otherfilelist', data)

export const getJX = (data) => ajax_get('/jxdcbinfo', data);

export const postJX = (data) => ajax_post('/jxdcbsave', data);

